import { useEffect, useState, useContext } from "react";
import styles from "./styles.module.css";
import ClickAwayListener from "react-click-away-listener";
import { DatabaseValue } from "../../../../contexts/database";
export default function Editor({ value, onChange, table }) {
  const [valid, setValid] = useState();

  return (
    <div className={styles.editor}>
      <Pill
        value={value}
        table={table}
        type="True/False"
        list={false}
        onChange={onChange}
      />
    </div>
  );
}

const Pill = ({ value, table, onChange, type, list }) => {
  const [open, setOpen] = useState(false);
  const [valid, setValid] = useState(false);
  const options = useSecurityOptions(value, table);

  useEffect(() => {
    const length = Object.keys(value).length;
    const last = value[length - 1];
    console.log(length, value);
    if (last && last.returnType === type && last.returnList === list) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [value]);
  const handleSelect = (option) => {
    const length = Object.keys(value).length;
    const _value = { ...value };
    if (option.param) {
      _value[length] = { ...option, paramValue: {} };
      onChange(_value);
    } else {
      _value[length] = option;
      onChange(_value);
    }
    if (option.returnType === type && option.returnList === list) {
      setOpen(false);
    }
  };

  const handleParamChange = (index, paramValue) => {
    const _value = { ...value };
    _value[index].paramValue = paramValue;
    onChange(_value);
  };
  const handleBack = () => {
    const length = Object.keys(value).length;
    const _value = { ...value };
    delete _value[length - 1];
    onChange(_value);
  };

  const handleClick = (event) => {
    event.stopPropagation();
    setOpen(true);
  };
  if (Object.keys(value).length === 0) {
    return (
      <>
        <span onClick={handleClick} className={styles.pill}>
          <span>select...</span>
        </span>
        <DropDown
          onSelect={handleSelect}
          open={open}
          options={options}
          onClose={() => setOpen(false)}
        />
      </>
    );
  }
  return (
    <>
      <span
        onClick={handleClick}
        className={valid ? `${styles.pill} ${styles.valid}` : styles.pill}
      >
        {Object.values(value).map((v, i) => {
          if (v.param) {
            return (
              <span>
                {v.displayName} [{" "}
                <Pill
                  value={v.paramValue}
                  table={table}
                  type={v.param.type}
                  list={v.param.list}
                  onChange={(value) => handleParamChange(i, value)}
                />{" "}
                ]
              </span>
            );
          }
          return <span>{v.displayName} </span>;
        })}
      </span>
      <DropDown
        onSelect={handleSelect}
        open={open}
        options={options}
        onClose={() => setOpen(false)}
        onBack={handleBack}
      />
    </>
  );
};
const DropDown = ({ open, onClose, options, onSelect, onBack }) => {
  const handleSelect = (event, o) => {
    event.stopPropagation();
    onSelect(o);
  };
  if (!open) {
    return null;
  }
  return (
    <ClickAwayListener onClickAway={onClose}>
      <div onClick={(e) => e.stopPropagation()} className={styles.dropdown}>
        {onBack && (
          <div className={styles.back} onClick={onBack}>
            ← Back
          </div>
        )}
        {options.map((o) => {
          return (
            <div
              onClick={(e) => handleSelect(e, o)}
              className={styles.dropdownOption}
            >
              {o.displayName}
            </div>
          );
        })}
      </div>
    </ClickAwayListener>
  );
};

const useSecurityOptions = (value, table) => {
  const [_, set_] = useState([]);
  const tables = useContext(DatabaseValue);

  useEffect(() => {
    if (Object.keys(value).length === 0) {
      return set_([
        {
          name: "user",
          displayName: "current user",
          returnType: "user",
          returnList: false,
        },
        {
          name: "self",
          displayName: "this " + table.name,
          returnType: table.id,
          returnList: false,
        },
      ]);
    }
    const length = Object.keys(value).length;
    const { returnType, returnList, param } = value[length - 1];

    //handle no return type
    if (!returnType) {
      return set_([
        {
          name: "user",
          displayName: "current user",
          returnType: "user",
          returnList: false,
        },
        {
          name: "self",
          displayName: "this " + table.name,
          returnType: table.id,
          returnList: false,
        },
      ]);
    }

    //handle true/false
    if (returnType === "True/False") {
      const boolOpts = [
        {
          name: " && ",
          displayName: "and",
          returnType: null,
          returnList: false,
        },
        {
          name: " || ",
          displayName: "or",
          returnType: null,
          returnList: false,
        },
      ];
      return set_(boolOpts);
    }
    //handle List
    if (returnList) {
      return set_([
        {
          name: "includes",
          displayName: "includes",
          returnType: "True/False",
          returnList: false,
          param: { type: returnType, list: false },
        },
        {
          name: "notinclude",
          displayName: "doesn't include",
          returnType: "True/False",
          returnList: false,
          param: { type: returnType, list: false },
        },
      ]);
    }
    let opts = [];
    //handle user type

    if (returnType === "user") {
      const userotps = [
        {
          name: "loggedIn",
          displayName: "is logged in",
          returnType: "True/False",
          returnList: false,
        },
        {
          name: "notLoggedIn",
          displayName: "is not logged in",
          returnType: "True/False",
          returnList: false,
        },
      ];
      opts = [...opts, ...userotps];
    }
    const basic = [
      {
        name: " === ",
        displayName: "is",
        returnType: "True/False",
        returnList: false,
        param: { type: returnType, list: false },
      },
      {
        name: " !== ",
        displayName: "is not",
        returnType: "True/False",
        returnList: false,
        param: { type: returnType, list: false },
      },
      {
        name: ".isNotEmpty",
        displayName: "is Not Empty",
        returnType: "True/False",
        returnList: false,
      },
    ];
    opts = [...opts, ...basic];

    //Handle IF Table Type

    const _table = tables.find((x) => x.id === returnType);
    if (_table) {
      const fieldOptions = Object.keys(_table.fields).map((key) => {
        return {
          name: "." + key,
          displayName: _table.fields[key].name,
          returnType: _table.fields[key].type,
          returnList: _table.fields[key].list,
        };
      });
      opts = [...opts, ...fieldOptions];
    }

    //Handle If Basic Type
    if (returnType === "True/False") {
      const boolOpts = [
        {
          name: " && ",
          displayName: "and",
          returnType: null,
          returnList: false,
        },
        {
          name: " || ",
          displayName: "or",
          returnType: null,
          returnList: false,
        },
      ];
      opts = [...opts, ...boolOpts];
    }

    set_(opts);
  }, [value, table]);

  return _;
};
